<template>
  <div
    class="soc-status-label"
    :class="[`soc-status-label--${size}`]"
    :style="{ 'background-color': socStatusColorMap[socStatus] }"
  >
    <span>{{ $t(`tickets.socStatuses.${socStatus}`) }}</span>
    <v-icon v-if="appendIcon" color="primary" size="14" :icon="appendIcon"></v-icon>
  </div>
</template>

<script setup lang="ts">
import { SocStatus, socStatusColorMap } from "@/constants/tickets";

withDefaults(
  defineProps<{
    socStatus: SocStatus;
    size?: "small" | "regular";
    appendIcon?: string;
  }>(),
  { size: "small" }
);
</script>

<style lang="scss" scoped>
.soc-status-label {
  flex-grow: 0;
  display: inline-flex;
  gap: 4px;
  border-radius: 4px;
  font-weight: 600;
  color: rgb(var(--v-theme-primary));
  text-transform: uppercase;

  &--small {
    height: 16px;
    padding: 2px 4px;
    font-size: 11px;
    line-height: 1.1;
    letter-spacing: 0.5px;
  }

  &--regular {
    height: 24px;
    padding: 4px 4px 4px 8px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.3;
    letter-spacing: 0.5px;
  }
}

.v-icon::before {
  color: rgb(var(--v-theme-primary)) !important;
}
</style>
